import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { store } from "../store";
import {
    templateActions,
    templateStore,
} from "@pages/Applications/C&C/C&CSetup/templateStore";

import { StyledButton } from "@aureskonnect/react-ui";

export function MediaDisplay({ item, section }: any) {
    const { t } = useTranslation();
    const { selectedLanguage } = useSnapshot(store);
    const snap = useSnapshot(templateStore);
    const data = templateActions.getNestedObject([
        "template",
        "SiteWeb",
        "LaindingPage",
        section,
    ]);
    const titleColor = templateActions.getNestedObject([
        "template",
        "SiteWeb",
        "Divers",
        "CouleurTitre",
    ]);
    const buttonColor = templateActions.getNestedObject([
        "template",
        "SiteWeb",
        "Divers",
        "CouleurPrincipale",
    ]);
    const mediaItem = item.Pub || item;

    const getImageUrl = React.useCallback(() => {
        if (!mediaItem?.Url) return "";
        if (mediaItem.Url.startsWith("blob:")) {
            return mediaItem.Url;
        }
        if (
            mediaItem.Url.startsWith("http") ||
            mediaItem.Url.startsWith("https")
        ) {
            return mediaItem.Url;
        }
        return `https://dev-site-api.challenges360.com/${snap.iuud}/${mediaItem.Url}`;
    }, [mediaItem?.Url, snap.iuud]);

    const mediaType =
        mediaItem?.Type ||
        (mediaItem?.Url?.endsWith(".mp4") ? "video/mp4" : "image");

    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                height: "100%",
                overflow: "hidden",
            }}
        >
            {mediaType.includes("video") ? (
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "fill",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 1,
                    }}
                >
                    <source src={getImageUrl()} type={mediaType} />
                    Your browser does not support the video tag.
                </video>
            ) : (
                <img
                    src={getImageUrl()}
                    alt={mediaItem.Name || "Banner image"}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "fill",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 1,
                    }}
                />
            )}

            <div
                style={{
                    position: "relative",
                    zIndex: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    padding: "1rem",
                }}
            >
                <div
                    style={{
                        color: titleColor,
                        fontSize: "2rem",
                        fontWeight: "bold",
                        marginBottom: "0.5rem",
                    }}
                >
                    {data.Title?.[selectedLanguage] || ""}
                </div>

                {data.Description && (
                    <div
                        style={{
                            color: titleColor,
                            fontSize: "1rem",
                            fontWeight: "bold",
                            maxWidth: "80%",
                        }}
                    >
                        {data.Description?.[selectedLanguage] || ""}
                    </div>
                )}

                {(section === "Bannier" || section === "Section3") && (
                    <StyledButton
                        className="mt-3 w-20 rounded"
                        style={{
                            color: "white",
                            backgroundColor: `${buttonColor}`,
                        }}
                    >
                        {t("To order")} {"->"}
                    </StyledButton>
                )}
            </div>
        </div>
    );
}
